module.exports = __webpack_public_path__ + "static/media/hand-point-down.4abb01d2.svg";